// extracted by mini-css-extract-plugin
module.exports = {"body__title":"CookiesBody_body__title__Y4Idq","body__list":"CookiesBody_body__list__kY0_K"};